/**
 * Frontend-side mirror of the Spatie permission names created by
 * Backend/database/seeders/RolesAndPermissionsInitSeeder.php. Keep the
 * KEY names in sync with what the seeder writes to the `permissions`
 * table — the value strings MUST match exactly, character-for-character,
 * because Spatie compares by string.
 *
 * Any name a route middleware or a backend can() check uses, and that the
 * frontend asks about, belongs here. Call sites write PERM.X, never the string
 * (guard fe-permission-literal).
 * Grep for hardcoded ability strings on either side before adding a new
 * permission — if it isn't in this file, someone forgot to sync it.
 */
export const PERM = {
  // Users
  VIEW_USERS:   'view users',
  CREATE_USERS: 'create users',
  EDIT_USERS:   'edit users',
  DELETE_USERS: 'delete users',

  // Vendors
  VIEW_VENDORS:   'view vendors',
  CREATE_VENDORS: 'create vendors',
  EDIT_VENDORS:   'edit vendors',
  DELETE_VENDORS: 'delete vendors',

  // Customers
  VIEW_CUSTOMERS:   'view customers',
  CREATE_CUSTOMERS: 'create customers',
  EDIT_CUSTOMERS:   'edit customers',
  DELETE_CUSTOMERS: 'delete customers',

  // Transactions
  VIEW_TRANSACTIONS: 'view transactions',

  // Employees
  VIEW_EMPLOYEES:        'view employees',
  CREATE_EMPLOYEES:      'create employees',
  DELETE_EMPLOYEES:      'delete employees',
  BULK_IMPORT_EMPLOYEES: 'bulk import employees',

  // Profile
  UPDATE_PROFILE: 'update profile',

  // Bookings
  BOOK_RESERVATIONS:             'book reservations',
  VIEW_OWN_RESERVATIONS:         'view own reservations',
  BOOK_MULTI_ROOM_RESERVATIONS:  'book multi-room reservations',

  // Fees + chains
  MANAGE_CUSTOMER_FEES: 'manage customer fees',
  MANAGE_HOTEL_CHAINS:  'manage hotel chains',

  // Policies
  VIEW_POLICIES:       'view policies',
  MANAGE_POLICIES:     'manage policies',
  VIEW_POLICY_REVIEWS: 'view policy reviews',
  APPROVE_POLICIES:    'approve policies',

  // Tags
  VIEW_TAGS:   'view tags',
  MANAGE_TAGS: 'manage tags',

  // Billing + integrations
  MANAGE_BILLING:      'manage billing',
  MANAGE_INTEGRATIONS: 'manage integrations',

  // MSI operations and scope (ADR-0038)
  MANAGE_STAFF_RESERVATIONS: 'manage staff reservations',
  MANAGE_VCC_CARDS:          'manage vcc cards',
  VIEW_ALL_CUSTOMERS:        'view all customers',

  // Direct-permission grants — see docs/authorization/direct-permissions.md.
  // Super Admin only.
  MANAGE_USER_PERMISSIONS: 'manage user permissions',
};

// Freeze so a typo like PERM.MANAGE_TAG = ... at a call site throws in
// strict mode instead of silently writing a garbage property.
Object.freeze(PERM);
